import { useAuth } from "@/src/contexts/auth.context";
import { EventItem } from "@/src/models/event.model";
import {
  useGetUserArchivedEventIdsQuery,
  useUpdateUserArchivedEventIdsMutation,
} from "@/src/services/api/profile/profile.hooks";
import { useCallback } from "react";

export const useEventArchive = () => {
  const { user } = useAuth();
  const currentUserId = user?.itemId ?? "";

  const { data: archivedEventIds = [] } =
    useGetUserArchivedEventIdsQuery(currentUserId);

  const { mutate: updateUserProfile } = useUpdateUserArchivedEventIdsMutation();

  const handleArchiveEvent = useCallback(
    (event: EventItem) => {
      const isArchived = archivedEventIds.includes(event.ItemId);
      const updatedArchivedEventIds = isArchived
        ? archivedEventIds.filter((id: string) => id !== event.ItemId)
        : [...archivedEventIds, event.ItemId];

      updateUserProfile({
        CreatedBy: currentUserId,
        archivedEventIds: updatedArchivedEventIds,
      });
    },
    [archivedEventIds, currentUserId, updateUserProfile],
  );

  const isEventArchived = useCallback(
    (eventId: string) => archivedEventIds.includes(eventId),
    [archivedEventIds],
  );

  return {
    archivedEventIds,
    handleArchiveEvent,
    isEventArchived,
  };
};
